import React, { useState, useEffect } from "react";
import { Container, Grid, Typography, Box, Card, CardContent } from "@mui/material";

const Counter = ({ end, duration }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 10);
    const interval = setInterval(() => {
      start += increment;
      setCount(Math.min(Math.floor(start), end));
      if (start >= end) clearInterval(interval);
    }, 10);
    return () => clearInterval(interval);
  }, [end, duration]);

  return <Typography variant="h4" fontWeight="bold" sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" } }}>{count.toLocaleString()}+</Typography>;
};

const Achievements = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 5 }}>
      <Grid container spacing={4} alignItems="center">
        {/* Text Section */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold" color="textSecondary">
            OUR COMMITMENT
          </Typography>
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Excellence in Vehicle Transport
          </Typography>
          <Typography variant="body1" color="textSecondary" gutterBottom>
            We go beyond just numbers, ensuring secure and reliable vehicle shipping with a focus on customer satisfaction and industry excellence.
          </Typography>
          <Box mt={2}>
            <Typography variant="body1" gutterBottom>✔ Thousands of Happy Clients</Typography>
            <Typography variant="body1" gutterBottom>✔ Secure & On-Time Deliveries</Typography>
            <Typography variant="body1">✔ Trusted Industry Leader</Typography>
          </Box>
        </Grid>
        
        {/* Image Section with Stats Overlay */}
        <Grid item xs={12} md={6} sx={{ position: "relative" }}>
          <Box
            component="img"
            src="/service_img3.jpg"
            alt="Enclosed Vehicle Transport"
            sx={{ width: "90%", borderRadius: 2, marginLeft: "8%" }}
          />
          <Box 
            sx={{ 
              position: "absolute", 
              bottom: { xs: 10, md: 20 }, 
              left: { xs: 10, md: 20 }, 
              display: "flex", 
              gap: 2, 
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center"
            }}
          >
            <Card sx={{ backgroundColor: "#FFC107", color: "black", textAlign: "center", p: { xs: 1, sm: 2 }, minWidth: { xs: "120px", sm: "160px" } }}>
              <CardContent>
                <Counter end={10000} duration={2000} />
                <Typography variant="body1" sx={{ fontSize: { xs: "0.8rem", sm: "1rem" } }}>Vehicles Safely Delivered</Typography>
              </CardContent>
            </Card>
            <Card sx={{ backgroundColor: "#0A1929", color: "white", textAlign: "center", p: { xs: 1, sm: 2 }, minWidth: { xs: "120px", sm: "160px" } }}>
              <CardContent>
                <Counter end={5000} duration={2000} />
                <Typography variant="body1" sx={{ fontSize: { xs: "0.8rem", sm: "1rem" } }}>Satisfied Customers</Typography>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Achievements;
